import React, { useEffect, useState } from 'react';
import FormFields from '../../../Forms/FormFields';
import './CoverageDetails.css';
import SelectionModal from '../../../../components/common/SelectionModal';
import { linkedFacilitiesCoverage, villageCoverage, wardsCoverage } from '../../../../constants';

interface formDataType {
  [key: string]: any;
}
type propsType = {
  formData: {
    [key: string]: any;
  };
  formState: any;
  handleFormChange: (value: any, key: string, details?:any) => void;
  onDropDownClick: (key:string) => void
};

const CoverageDetails = ({ formData, formState, handleFormChange, onDropDownClick }: propsType) => {
  const [selectionLF, setSelectionLF] = useState<boolean>(false);
  const [selectionVillages, setSelectionVillages] = useState<boolean>(false);
  const [selectionGramPanchayats, setSelectionGramPanchayats] = useState<boolean>(false);
  const [selectionWards, setSelectionWards] = useState<boolean>(false);

  const [savedLF, setSavedLF] = useState<{ [key: string]: string }>({});
  const [savedVillages, setSavedVillages] = useState<{ [key: string]: string }>({});
  const [savedGramPanchayats, setSavedGramPanchayats] = useState<{ [key: string]: string }>({});
  const [savedWards, setSavedWards] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    if (formState?.linked_facilities?.isModalOpen) {
      setSelectionLF(true);
    }
    if (formState?.villages_covered?.isModalOpen) {
      setSelectionVillages(true);
    }
    if (formState?.gram_panchayat_covered?.isModalOpen) {
      setSelectionGramPanchayats(true);
    }
    if (formState?.wards_covered?.isModalOpen) {
      setSelectionWards(true);
    }
  }, [formState])

  let linkedFaciltiesOptionsObject: any = {};
  let villagesCoveredOptionsObject: any = {};
  let gramPanchayatCoveredOptionsObject: any = {};
  let wardsCoveredOptionsObject: any = {};
  const formKeys = Object.keys(formData) as (keyof formDataType)[];
  formKeys.map((element: any) => {
    const field: formDataType = formData[element];
    const dataOptions = field['#options'];
    const linkedFaciltiesOptions: any = [];
    const villagesCoveredOptions: any = [];
    const gramPanchayatCoveredOptions: any = [];
    const wardsCoveredOptions: any = [];
    const options2: string[] = dataOptions ? Object.values(dataOptions) : [];
    if (field['#webform_key'] == 'linked_facilities') {
      options2.map((option1: any) => {
        linkedFaciltiesOptions.push(option1?.facility_name)
      })
      linkedFaciltiesOptionsObject = linkedFaciltiesOptions.reduce((acc: any, current: any) => {
        if (!acc[current]) {
          acc[current] = current;
        }
        return acc;
      }, {});
    }
    //will implement below once we have wards and village coverage using api
    if (field['#webform_key'] == 'wards_covered') {
      options2.map((option1: any) => {
        wardsCoveredOptions.push(option1?.value)
      })
      wardsCoveredOptionsObject = wardsCoveredOptions.reduce((acc: any, current: any) => {
        if (!acc[current]) {
          acc[current] = current;
        }
        return acc;
      }, {});
    }
    if (field['#webform_key'] == 'villages_covered') {
      options2.map((option1: any) => {
        villagesCoveredOptions.push(option1?.village_name)
      })
      villagesCoveredOptionsObject = villagesCoveredOptions.reduce((acc: any, current: any) => {
        if (!acc[current]) {
          acc[current] = current;
        }
        return acc;
      }, {});
    }
    if (field['#webform_key'] == 'gram_panchayat_covered') {
      options2.map((option1: any) => {
        gramPanchayatCoveredOptions.push(option1?.gram_panchayat_name)
      })
      gramPanchayatCoveredOptionsObject = gramPanchayatCoveredOptions.reduce((acc: any, current: any) => {
        if (!acc[current]) {
          acc[current] = current;
        }
        return acc;
      }, {});
    }
  })

  const [linkedFacilities, setLinkedFacilities] = useState(linkedFaciltiesOptionsObject)
  const [villages, setVillages] = useState(villagesCoveredOptionsObject);
  const [gramPanchayat, setGramPanchayat] = useState(gramPanchayatCoveredOptionsObject);
  const [wards, setWards] = useState(wardsCoveredOptionsObject);

  const [linkedFacilitiesDetails, setLinkedFacilitiesDetails] = useState<any>({});
  const [villagesDetails, setVillagesDetails] = useState<any>({});
  const [gramPanchayatDetails, setGramPanchayatDetails] = useState<any>({});
  const [wardsDetails, setWardsDetails] = useState<any>({});

  const [selectedLinkedFacilities, setSelectedLinkedFacilities] = useState<any>({})
  const [selectedVillageDetails, setSelectedVillageDetails] = useState<any>({})
  const [selectedGramPanchayatDetails, setSelectedGramPanchayatDetails] = useState<any>({})
  const [selectedWardsDetails, setSelectedWardsDetails] = useState<any>({})

  
  
  

  useEffect(() => {
    const formKeys = Object.keys(formData) as (keyof formDataType)[];
    formKeys.map((element: any) => {
      const field: formDataType = formData[element];
      const dataOptions = field['#options'];
      const options2: string[] = dataOptions ? Object.values(dataOptions) : [];
  
      if (field['#webform_key'] == 'linked_facilities') {
        const linkedFacilitiesDetailsTemp: any = {};
        options2.map((option1: any) => {
          linkedFacilitiesDetailsTemp[option1.facility_name] = {
            facility_name:option1.facility_name,
            facility_id: option1.facility_id,
            facility_code: option1.facility_code,
          };
        });
        setLinkedFacilitiesDetails(linkedFacilitiesDetailsTemp);
      }
  
      if (field['#webform_key'] == 'villages_covered') {
        const villagesDetailsTemp: any = {};
        options2.map((option1: any) => {
          villagesDetailsTemp[option1.village_name] = {
            village_name: option1.village_name,
            village_id: option1.village_id,
            village_code: option1.village_code,
          };
        });
        setVillagesDetails(villagesDetailsTemp);
      }

      if (field['#webform_key'] == 'gram_panchayat_covered') {
        const gramPanchayatDetailsTemp: any = {};
        options2.map((option1: any) => {
          gramPanchayatDetailsTemp[option1.gram_panchayat_name] = {
            gram_panchayat_name: option1.gram_panchayat_name,
            gram_panchayat_id: option1.gram_panchayat_id,
            gram_panchayat_code: option1.gram_panchayat_code,
          };
        });
        setGramPanchayatDetails(gramPanchayatDetailsTemp);
      }
  
      if (field['#webform_key'] == 'wards_covered') {
        const wardsDetailsTemp: any = {};
        options2.map((option1: any) => {
          wardsDetailsTemp[option1.value] = {
            ward_name:option1.value,
            ward_id: option1.id,
            ward_code: option1.code,
          };
        });
        setWardsDetails(wardsDetailsTemp);
      }
    });
  }, [formData]);

  

  const onhandleSaveLF = (selectedItems: { [key: string]: string }, flag: boolean, selectedItemsDetails:any) => {
    
    setSavedLF({...selectedItems});
    handleFormChange(selectedItems, 'linked_facilities',selectedItemsDetails);
    // selectedItems? formState.linked_facilities.value = selectedItems : formState.linked_facilities.value = null
    setSelectedLinkedFacilities({...selectedItems});
    setSelectionLF(flag);
    // formState.linked_facilities.isModalOpen ? formState.linked_facilities.isModalOpen = false : null;
  };

  const onhandleSaveVillages = (selectedItems: { [key: string]: string }, flag: boolean,selectedItemsDetails:any) => {
    // 
    setSavedVillages({...selectedItems});
    handleFormChange(selectedItems, 'villages_covered',selectedItemsDetails);
    setSelectedVillageDetails({...selectedItems})
    // selectedItems ? formState.villages_covered.value = selectedItems : formState.villages_covered.value = null
    setSelectionVillages(flag);
    // formState.villages_covered.isModalOpen ? formState.villages_covered.isModalOpen =false : null;
  };

  const onhandleSaveGramPanchayats = (selectedItems: { [key: string]: string }, flag: boolean,selectedItemsDetails:any) => {
    setSavedGramPanchayats({...selectedItems});
    handleFormChange(selectedItems, 'gram_panchayat_covered',selectedItemsDetails);
    setSelectedGramPanchayatDetails({...selectedItems})
    setSelectionGramPanchayats(flag);
  };

  const onhandleSaveWards = (selectedItems: { [key: string]: string }, flag: boolean,selectedItemsDetails:any) => {
    // 
    setSavedWards({...selectedItems});
    handleFormChange(selectedItems, 'wards_covered',selectedItemsDetails);
    setSelectedWardsDetails({...selectedItems})
    // selectedItems ? formState.wards_covered.value = selectedItems : formState.wards_covered.value = null
    setSelectionWards(flag);
    // formState.wards_covered.isModalOpen ? formState.wards_covered.isModalOpen = false : null;
  };

  //selection DropDown
  
  const savedItems = {
    linked_facilities: savedLF,
    villages_covered: savedVillages,
    gram_panchayat_covered: savedGramPanchayats,
    wards_covered: savedWards
  }
  return (
    <div className="create_coverage_details_page">
      <form className="form_container_coverage_details">
        <FormFields
          formData={formData}
          formState={formState}
          handleFormChange={handleFormChange}
          savedItems={savedItems}
          onDropDownClick={onDropDownClick}
        />
        {selectionLF && (
          <SelectionModal 
            items={linkedFacilities}
            onSave={onhandleSaveLF} 
            title='Linked Facilities Selected' 
            searchPlaceholder={'Search By Linked Facilities'} 
            details={linkedFacilitiesDetails}
            selectedItemsProps={selectedLinkedFacilities}
             />

        )}
        {selectionVillages && (
          <SelectionModal items={villages} onSave={onhandleSaveVillages} title='Villages Selected' searchPlaceholder={'Search By Villages'} 
          details={villagesDetails} 
          selectedItemsProps={selectedVillageDetails}
          />

        )}
        {selectionGramPanchayats && (
          <SelectionModal items={gramPanchayat} onSave={onhandleSaveGramPanchayats} title='Gram Panchayats / ADC Villages Selected' searchPlaceholder={'Search By Gram Panchayats / ADC Villages'} 
          details={gramPanchayatDetails} 
          selectedItemsProps={selectedGramPanchayatDetails}
          />

        )}
        {selectionWards && (

          <SelectionModal items={wards} onSave={onhandleSaveWards} title='Wards Selected' searchPlaceholder={'Search By Wards'} 
            details={wardsDetails}
            selectedItemsProps={selectedWardsDetails}
            />

        )}

      </form>





    </div>
  );
};
export default CoverageDetails;
